exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".empty-container {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  text-align: center;\n  padding: 20px 60px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n  .empty-container h3 {\n    padding: 0px;\n    margin: 0px;\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: #616161; }\n  .empty-container p {\n    padding: 0px 0px;\n    font-size: 0.9rem;\n    color: #A2A2A2; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/sass-loader/lib/loader.js!./src/shared/components/emptyContainer.scss
// module id = 1140
// module chunks = 0